import React, { createContext, useContext, useState, useEffect } from 'react';

const AuctioneerContext = createContext();

export const useAuctioneer = () => {
  const context = useContext(AuctioneerContext);
  if (!context) {
    throw new Error('useAuctioneer must be used within AuctioneerProvider');
  }
  return context;
};

export const AuctioneerProvider = ({ children }) => {
  const [auctioneer, setAuctioneer] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const storedToken = localStorage.getItem('auctioneer_token');
    const storedAuctioneer = localStorage.getItem('auctioneer_user');
    
    if (storedToken && storedAuctioneer) {
      setToken(storedToken);
      setAuctioneer(JSON.parse(storedAuctioneer));
    }
    
    setLoading(false);
  }, []);

  const login = async (email, password, totpCode) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auctioneer/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password, totp_code: totpCode }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Login failed');
      }

      const data = await response.json();
      
      localStorage.setItem('auctioneer_token', data.access_token);
      localStorage.setItem('auctioneer_user', JSON.stringify({
        email: data.email,
        role: data.role,
        auction_id: data.auction_id
      }));
      
      setToken(data.access_token);
      setAuctioneer({
        email: data.email,
        role: data.role,
        auction_id: data.auction_id
      });
      
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    localStorage.removeItem('auctioneer_token');
    localStorage.removeItem('auctioneer_user');
    setToken(null);
    setAuctioneer(null);
  };

  const value = {
    auctioneer,
    token,
    loading,
    isAuthenticated: !!token,
    login,
    logout,
  };

  return <AuctioneerContext.Provider value={value}>{children}</AuctioneerContext.Provider>;
};
